<template>
  <div class="my-table userPage">
    <!-- 面包屑组件 -->
    <div class="searchBox flexCenter">
      <div class="current-location">
        <img class="location" src="@/assets/picture/icon/location.png">
        <span>{{$t('editPhone.txt1')}}</span>
        <span>{{$t('editPhone.txt2')}} / {{$t('editPhone.txt3')}}</span>
      </div>
    </div>
    <!-- 面包屑 -->
    <el-card class="tableCard p30">
      <div class="contactTitle flexCenter mb50">
        <span>{{!isNext?$t('editPhone.txt3'):$t('editPhone.txt4')}}</span>
        <div class="flexEnd">
          <div class="onCancelBtn mr30" @click="onBack">{{$t('editPhone.txt5')}}</div>
          <div v-if="!isNext" class="searchBtn verification" @click="nextPhoneForm('phoneForm')">{{$t('editPhone.txt6')}}</div>
          <div v-else class="searchBtn" @click="confirmPhoneForm('newPhoneForm')">{{$t('editPhone.txt7')}}</div>
        </div>
      </div>
      <div class="editForm phoneForm" v-if="!isNext">
        <el-form :model="phoneForm" :rules="editPhoneRules" ref="phoneForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('editPhone.txt8')" prop="mobile">
            <el-input  :disabled="isMoblie"
            :placeholder="$t('editPhone.txt9')"
            v-model="phoneForm.mobile">
          </el-input>
        </el-form-item>
        <el-form-item :label="$t('editPhone.txt10')" prop="code">
          <div class="handleBoxSeach flexCenter">
            <el-input :placeholder="$t('editPhone.txt11')"  v-model="phoneForm.code"></el-input>
            <div>
              <div v-if="showPhone == 1" class="searchBtn">{{$t('editEmail.txt12')}}{{countPhone}}{{$t('editEmail.txt13')}}</div>
              <div v-else class="searchBtn" @click="onSendPhoneCode">{{showPhone == 0?$t('editPhone.txt13'):$t('editPhone.txt14')}}</div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="editForm phoneForm" v-else>
        <el-form :model="newPhoneForm" :rules="editNewPhoneRules" ref="newPhoneForm" label-width="100px" class="demo-ruleForm">
          <el-form-item :label="$t('editPhone.txt15')" prop="mobile">
            <el-input
            :placeholder="$t('editPhone.txt16')"
            v-model="newPhoneForm.mobile">
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </el-card>
</div>
</template>

<script>
  import qs from 'qs';
  export default {
    data() {
      return {
        queryData:{},
        id:'',
        isNext:false,
        // 手机号码校验
        editPhoneRules:{
         mobile: [
         { required: true, message: this.$t('editPhone.txt17'), trigger: 'blur' },
         { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,message: this.$t('editPhone.txt18'),trigger: "blur"},
         ],
         code:[
         { required: true, message: this.$t('editPhone.txt19'), trigger: 'blur' }
         ],
       },
       phoneForm: {},//编辑手机号码参数
       showPhone:0,
       countPhone:0,
       timerPhone: null,
       newPhoneForm:{},//新手机号码参数
       isMoblie:false,//判断是否存在手机号
       // 新手机号码校验
        editNewPhoneRules:{
         mobile: [
         { required: true, message: this.$t('editPhone.txt17'), trigger: 'blur' },
         { pattern: /^1[3|4|5|6|7|8|9][0-9]\d{8}$/,message: this.$t('editPhone.txt19'),trigger: "blur"},
         ],
       },
     };
   },
   created() {
    this.infoDetail();
  },
  methods: {
     // 获取用户信息
      async infoDetail() {
        const { data: res } = await this.$http.get('/user/info/detail');
        this.queryData = {
          ...res.result
        };
        if(this.queryData.mobile){
          this.isMoblie = true;
          this.phoneForm.mobile = this.queryData.mobile;
        }
      },
      onBack(){
        this.$router.go(-1);
      },
      // 校验进入下一步
      nextPhoneForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.checkCode();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 个人中心-校验验证码
		async checkCode() {
			let data = {
        code:this.phoneForm.code,
        type:1
      }
			const { data: res } = await this.$http.get("/user/info/checkCode?" + qs.stringify(data));
			if (!res.success) {
				return this.$message.error(res.message);
			}
      this.isNext = true;
		},
      // 绑定手机号
      confirmPhoneForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.savaMobile();
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      // 个人中心-绑定手机
		async savaMobile() {
			let data = {
        code:this.phoneForm.code,
        mobile:this.phoneForm.mobile,
        userId:localStorage.userId
      }
			const { data: res } = await this.$http.get("/user/info/savaMobile?" + qs.stringify(data));
			if (!res.success) {
				return this.$message.error(res.message);
			}
      this.onBack();
		},
      // 发送手机验证码
      async onSendPhoneCode(){
        var reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
        if(!reg.test(this.phoneForm.mobile)){
          return this.$message.error(this.$t('editPhone.txt17'));
        }
        const { data: res } = await this.$http.get("/user/info/getCodeByMobile?mobile="+this.phoneForm.mobile);
        if (!res.success) {
          return this.$message.error(res.message);
        }
        this.$message({
          message: res.message,
          type: 'success'
        });
              const times = 60; // 倒计时时间
              if (!this.timerPhone) {
                this.countPhone = times;
                this.showPhone = 1;
                this.timerPhone = setInterval(() => {
                  if (this.countPhone > 0 && this.countPhone <= times) {
                    this.countPhone--;
                  } else {
                    this.showPhone = 2;
                    clearInterval(this.timerPhone);
                    this.timerPhone = null;
                  }
                }, 1000)
              }   
            },
          },
        };

      </script>

      <style lang="less" scoped>

        .handleBtn{
          padding: 0;
        }
        .userPage{
          /deep/ .el-upload__input{
            display: none !important;
          }
          .searchBtn{
            min-width: 130px !important;
          }
          .verification{
            min-width: 88px !important;
          }
          .handleBoxSeach{
            background-color: #F4F4F4 !important;
          }
          /deep/ .el-date-editor .el-range-separator{
            margin-top: -5px;
            width: 8%;
          }
          .contactTitle{
            margin-bottom: 40px;
          }
          .contactTitle span{
            margin-right: 30px;
            cursor: pointer;
            font-size: 30px;
            font-weight: 500;
            color: #222222;
          }
          .w350{
            width: 350px;
          }
          .tips{      
            font-size: 1.4rem;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #98B9FF;
            margin-top: -10px;
          }
          .phoneForm{
            width: 50%;
            margin: 30px auto 260px auto;
            display: block;
            .handleBoxSeach{
              width: 100%;
            }
          }
        }

      </style>
